import * as React from "react";
import { connect } from "react-redux";
import ProgressiveImage from "react-progressive-image";
import { ImageHelper } from "../../../../utilities/image-helper";
import {
  TopLevelMediaKind,
  PreviewKind,
  StoryType,
  ArticleStory,
  PodcastStory,
  Entity,
  Person,
} from "@radivision/graphql";
import { formatTime } from "../../../../utilities/format-time";
import { SVGS } from "../../../../component-configuration/svgs";
import { PostModalLink } from "./post-modal-link";
import { GridImage } from "./styled";
import { PostMoreMenu } from "./post-more-menu";
import { AppState } from "../../../../redux";
import { Loader } from "../../../page/loader";

interface ComponentProps {
  item: StoryType;
  subject: Person | Entity;
}

interface MapStateProps {
  inProgress: boolean;
}

type Props = ComponentProps & MapStateProps;

export const PostItemComponent = (props: Props) => {
  const { item, subject, inProgress } = props;

  const previewImageUrl = React.useMemo(
    () =>
      ImageHelper.fetchOptimizedImageUrl({
        imageType: "PREVIEW",
        preview: {
          content: item.previews,
          previewKind: PreviewKind.SQUARE,
          topLevelMedia: TopLevelMediaKind.IMAGE,
        },
        desiredDimensions: { numberOfItems: 4, containerWidthRatio: 1 },
        isSquareImage: true,
        revision: item.revision,
      }),
    [item],
  );

  const duration = formatTime((item as PodcastStory)?.durationInSeconds || (item as ArticleStory)?.timeToReadInSeconds);

  return (
    <div className="post-item">
      <ProgressiveImage
        src={previewImageUrl?.requestedResolutionUrl || previewImageUrl?.screenResolutionUrl}
        placeholder={previewImageUrl?.placeHolderUrl}
      >
        {(src: any, LOADING: any, _srcSetData: any) => (
          <PostModalLink item={item}>
            <GridImage
              src={src}
              style={{
                opacity: LOADING ? 0 : 1,
                transition: "all 0.3s eas-in",
              }}
            >
              <Loader isActive={inProgress} />
              {duration && (
                <div className="overlay-item-meta">
                  <span className="duration">{duration}</span>
                </div>
              )}
            </GridImage>
          </PostModalLink>
        )}
      </ProgressiveImage>
      <h4 className="title">
        <PostModalLink item={item}>
          <span className={`story-icon ${item?.__typename}`}> {SVGS[item?.__typename]} </span>
          {item.title}
        </PostModalLink>
        <PostMoreMenu subject={subject} item={item} />
      </h4>
    </div>
  );
};

const mapState = (state: AppState, props: ComponentProps) => ({
  inProgress: state.cache.inProgress[`delete-post-${props.item?.id}`],
});

export const PostItem = connect(mapState)(PostItemComponent);
